import { NestedTreeControl } from '@angular/cdk/tree'
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSnackBar } from '@angular/material/snack-bar'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { CommandeSettingsCoeff, CommandeSettingsDeliveries } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { LingerieService } from '../../../settings/commande-param/commande-param-settings/shared/lingerie.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { CommandeDetails, CommandeList, ListLigneCommande } from '../../shared/commande'
import { CommandeService } from '../../shared/commande.service'
import { Inventaire, Lingerie } from '../../shared/inventaire'
import { BesoinStatutHelpComponent } from './besoin-statut-help/besoin-statut-help.component'

interface CommandeNode {
  id?: string
  date_livraison?: string
  date_transmission?: string
  numCommande?: string
  statut?: any
  emetteur?: any
  lingerie?: Lingerie
  date_modification?: string
  children?: CommandeNode[]
}

@Component({
  selector: 'app-besoin-list',
  templateUrl: './besoin-list.component.html',
  styleUrls: ['./besoin-list.component.scss']
})
export class BesoinListComponent implements OnInit, OnDestroy {

  public commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  public coefficient: CommandeSettingsCoeff
  treeControl = new NestedTreeControl<CommandeNode>(node => node.children)
  ELEMENT_DATA: MatTableDataSource<CommandeNode> = new MatTableDataSource<CommandeNode>()
  columns = [
    { id: 'date_livraison', libelle: 'Date de livraison' },
    { id: 'statut', libelle: 'Statut' },
  ]
  displayedColumns: Array<string> = ['date_livraison', 'statut', 'actions']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  loading: boolean = false
  commandeDetails: CommandeDetails
  inventaireDetails: Inventaire
  currentClient: Client
  isSideBarOpen: boolean = false
  sideBarData: ListLigneCommande[]
  isSideBarInventaireOpen: boolean = false
  sideBarInventaireData: Inventaire
  dateLivraison: string
  isSending: string = null
  inventaires = []
  isComptageLingerie: boolean = false
  hasInventaires: boolean = false
  subClient: Subscription
  enabledComplement: boolean = false
  popup

  constructor(
    private commandeService: CommandeService,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private commandeSettingsService: CommandeParamSettingsService,
    private lingerieService: LingerieService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    moment.locale('fr')

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      if (!this.currentClient.is_livraison_commande) {
        this.commandeService.getClientDotations(this.currentClient.id).subscribe(data => {
          if (data.length == 0) {
            this.router.navigate(['/escli']).then(() => {
              this.notificationService.notif("Ce client n'est pas client à la gestion du linge d'hébergement", 'error')
            })
          }
        })
      } else {
        this.router.navigate(['/escli/linge-hebergement/list'])
      }
      this.isComptageLingerie = this.currentClient.is_comptage_lingerie
      this.enabledComplement = this.currentClient.enabled_complement

      this.getCommandeList(this.currentClient)
      this.getClientDeliveries(this.currentClient)
    })

    this.paginator.page.subscribe(event => {
      this.getCommandeList(this.currentClient, event.pageIndex, event.pageSize);
    });
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getCommandeList(client: Client, page = 0, pageSize = this.paginator?.pageSize || 10) {
    this.loading = true
    this.commandeService.getCommandeList(client.id, page + 1, pageSize).subscribe(result => {
      let commandes = result['orders'];
      commandes.forEach(commande => {
        if (commande.inventaires.length > 0) {
          commande['children'] = commande.inventaires
        }
      })
      this.ELEMENT_DATA.data = commandes as CommandeNode[]
      this.paginator._intl.itemsPerPageLabel = 'Livraisons par page '
      this.paginator.length = result['count']
      this.loading = false
    })
  }

  getCommandeDetails(node) {
    this.loading = true
    if (node.children) {
      this.hasInventaires = true
    } else {
      this.hasInventaires = false
    }
    this.commandeService.getCommandeDetails(node.id).subscribe(data => {
      this.commandeDetails = data
      this.dateLivraison = data.date_livraison
      this.loading = false
      this.openSideBar(this.commandeDetails.lod_ligne_commandes)
    })
  }

  getInventaireDetails(inventaire: Inventaire) {
    if (!this.disabledVoir(inventaire)) {
      this.loading = true
      this.inventaireDetails = inventaire
      let commande = this.ELEMENT_DATA.data.find(el => el.children?.find(child => child.id == inventaire.id))

      this.commandeService.getInventaire(inventaire.id).subscribe(data => {
        this.inventaireDetails.inventaire_lignes = data.inventaire_lignes.filter(el => el.restant != null)

        this.dateLivraison = commande.date_livraison
        this.loading = false
        this.openSideBarInventaire(this.inventaireDetails)
      })
    }
  }

  private openSideBar(commandeDetails: ListLigneCommande[]) {
    this.sideBarData = commandeDetails
    window.scrollTo(0, 0)
    this.isSideBarOpen = true
    document.body.style.overflow = "hidden"
  }

  private openSideBarInventaire(inventaireDetails: Inventaire) {
    this.sideBarInventaireData = inventaireDetails
    window.scrollTo(0, 0)
    this.isSideBarInventaireOpen = true
    document.body.style.overflow = "hidden"
  }

  onSidebarClose() {
    this.isSideBarOpen = false
    document.body.style.overflow = "auto"
  }

  onSidebarInventaireClose() {
    this.isSideBarInventaireOpen = false
    document.body.style.overflow = "auto"
  }

  sendCommande(id) {
    this.isSending = id
    this.commandeService.sendCommande(id, this.currentClient).subscribe(async data => {
      this.ngOnInit()
      let list = data as Array<string>
      if (list.length > 0) {
        if (list.length == 1) {
          this.notificationService.notif("L'article " + list[0] + " n'est plus dans votre contrat, il est retiré de la commande", "warn", 5000)
        } else {
          this.notificationService.notif("Les articles " + list + " ne sont plus dans votre contrat, ils sont retirés de la commande", "warn", 5000)
        }
        const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
        await sleep(5000)
      }
      this.notificationService.notif("Commande transmise", "notif");
      this.isSending = null
    }, error => this.isSending = null)
  }

  isEditable(commande: CommandeList | CommandeNode) {
    return commande.statut.code !== 'V' && commande.statut.code !== 'AD' && commande.statut.code !== 'C' && commande.statut.code !== 'D'
  }

  isEditableInventaire(inventaire: CommandeList) {
    let commande = this.ELEMENT_DATA.data.find(el => el.children?.find(child => child.id == inventaire.id))
    return this.isEditable(commande)
  }

  isPartiel(commande: CommandeList | CommandeNode) {
    return commande.statut.code == 'AD'
  }

  isPrintable(commande: CommandeList) {
    return commande.statut.code === 'T' ||
      commande.statut.code === 'T0'
  }

  export(id) {
    this.commandeService.export(id, this.currentClient.id).subscribe()
  }

  delivered() {
    return new Date() >= new Date(this.dateLivraison)
  }

  getInventaires(commande) {
    let index = this.inventaires.findIndex(value => value.commande.id === commande.id)
    if (index != -1) {
      return this.inventaires[index].inventaires
    }
    return []
  }

  hasChildren = (index: number, node: CommandeNode) => {
    return node.children && node.children.length > 0
  }

  getClientDeliveries(client) {
    this.commandeSettingsService.getCommandDeliveries(client.id).subscribe(
      (data) => {
        this.commandeSettingsDeliveries = data
      }
    )
  }

  help() {
    this.dialog.open(BesoinStatutHelpComponent)
  }

  disabledVoir(node) {
    return node.statut.code == 'AS' || node.statut.code == 'NS'
  }

  isToday(date_livraison) {
    let today = new Date()
    return today.setHours(0, 0, 0, 0) == (new Date(date_livraison)).setHours(0, 0, 0, 0)
  }

  hasQteReception() {
    return this.sideBarData && this.sideBarData.some(value => value.qte_reception != null)
  }

  hasDispatch() {
    return this.sideBarInventaireData && this.sideBarInventaireData.inventaire_lignes.some(value => value.qte_dispatch != null)
  }

  hasComplement() {
    return this.sideBarInventaireData && this.sideBarInventaireData.inventaire_lignes.some(value => value.qte_complement != null)
  }

  hasDistribution() {
    return this.sideBarInventaireData && this.sideBarInventaireData.inventaire_lignes.some(value => value.qte_livree != null)
  }
}